module.exports = __webpack_public_path__ + "00b9a44abfd223c76fdd2f333bbb5f80.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-purpose-and-points-of-view.png
// module id = 2975
// module chunks = 0